import React from 'react';
import { homepageContent, siteContent } from '../../data/products';
import { buildWhatsAppUrl } from '../../utils/whatsapp';
import Icon from '../Icon/Icon';
import './CustomOrder.css';

/* Custom orders — a simple, warm invitation instead of a configurator:
 * whatever the customer dreams up, one tap starts the WhatsApp chat. */

const CustomOrder = () => {
  const content = homepageContent.customOrder;
  const customOrderUrl = buildWhatsAppUrl(
    siteContent.contact.whatsappNumber,
    siteContent.ordering.customOrderMessage
  );
  const phoneHref = `tel:+${siteContent.contact.whatsappNumber}`;

  return (
  <section id="custom-order" className="custom-order">
    <div className="co-inner">
      <div className="co-copy">
        <div className="section-tag">{content.eyebrow}</div>
        <h2 className="section-title">{content.title}</h2>
        <p className="section-subtitle">{content.description}</p>
        <ul className="co-examples" aria-label="Popular custom orders">
          {content.examples.map((example) => <li key={example}>{example}</li>)}
        </ul>
        <div className="co-actions">
          <a
            className="co-cta"
            href={customOrderUrl}
            target="_blank"
            rel="noreferrer"
          >
            <Icon name="whatsapp" size={18} />
            <span>{content.ctaLabel}</span>
          </a>
          <a className="co-call" href={phoneHref}>
            <Icon name="phone" size={16} />
            <span>{siteContent.contact.phoneDisplay}</span>
          </a>
        </div>
      </div>
      <figure className="co-photo">
        <img
          src={content.image}
          alt={content.imageAlt}
          loading="lazy"
        />
        <figcaption>{content.caption}</figcaption>
      </figure>
    </div>
  </section>
  );
};

export default CustomOrder;
